<template>
<div class="chapter">
<div class="inner_page">
<div class="galley">
<div class="frontmatter TableOfContents">
<p id="rw-p_131371-00001"><a id="pb-rw_xi">
</a></p><a id="pb-rw_xi">
<div class="title-block" id="rw-title-block_131371-00001">
<h1>CONTENTS</h1>
</div>
</a><div class="block toc"><a id="pb-rw_xi">
</a><p id="rw-p_131371-00002" style="text-align: center;"><a id="pb-rw_xi"></a><a href="#/9781847677440_intro">Introduction</a>
</p>
<p id="rw-p_131371-00003" style="text-align: center;"><a href="#/9781847677440_introduction#pb-rw_xiii">Author's Note Words are for the Mind</a>
</p>
<p id="rw-p_131371-00004" style="text-align: center;"><span href="#/9781847677440_chapter_01#pb-rw_7" title="Link target outside of Sample">Spirituals</span>
</p>
<p id="rw-p_131371-00005" style="text-align: center;"><span href="#/9781847677440_chapter_02#pb-rw_1" title="Link target outside of Sample">Coming from a Broken Home</span>
</p>
<p id="rw-p_131371-00006" style="text-align: center;"><span href="#/9781847677440_chapter_03#rw-title-block_131374-00001" title="Link target outside of Sample">The ‘Movie’ Poems</span>
</p>
<p id="rw-p_131371-00007" style="text-align: center;"><span href="#/9781847677440_part_01#pb-rw_8" title="Link target outside of Sample">‘B’ Movie Introduction</span>
</p>
<p id="rw-p_131371-00008" style="text-align: center;"><span href="#/9781847677440_part_02#pb-rw_10" title="Link target outside of Sample">‘B’ Movie – The Poem</span>
</p>
<p id="rw-p_131371-00009" style="text-align: center;"><span href="#/9781847677440_part_03#pb-rw_13" title="Link target outside of Sample">Re-Ron</span>
</p>
<p id="rw-p_131371-00010" style="text-align: center;"><span href="#/9781847677440_chapter_04#pb-rw_17" title="Link target outside of Sample">Space Shuttle</span>
</p>
<p id="rw-p_131371-00011" style="text-align: center;"><span href="#/9781847677440_chapter_05#pb-rw_21" title="Link target outside of Sample">Whitey on the Moon</span>
</p>
<p id="rw-p_131371-00012" style="text-align: center;"><span href="#/9781847677440_chapter_06#pb-rw_22" title="Link target outside of Sample">Black History</span>
</p>
<p id="rw-p_131371-00013" style="text-align: center;"><span href="#/9781847677440_chapter_07#pb-rw_25" title="Link target outside of Sample">Dr King</span>
</p>
<p id="rw-p_131371-00014" style="text-align: center;"><span href="#/9781847677440_chapter_08#pb-rw_27" title="Link target outside of Sample">A Toast to the People</span>
</p>
<p id="rw-p_131371-00015" style="text-align: center;"><span href="#/9781847677440_chapter_09#pb-rw_28" title="Link target outside of Sample">The World</span>
</p>
<p id="rw-p_131371-00016" style="text-align: center;"><span href="#/9781847677440_chapter_10#pb-rw_29" title="Link target outside of Sample">Work for Peace</span>
</p>
<p id="rw-p_131371-00017" style="text-align: center;"><span href="#/9781847677440_chapter_11#pb-rw_32" title="Link target outside of Sample">What You See Ain’t What You Goetz</span>
</p>
<p id="rw-p_131371-00018" style="text-align: center;"><span href="#/9781847677440_chapter_12#pb-rw_35" title="Link target outside of Sample">Thought Out</span>
</p>
<p id="rw-p_131371-00019" style="text-align: center;"><span href="#/9781847677440_chapter_13#pb-rw_37" title="Link target outside of Sample">Give Her a Call</span>
</p>
<p id="rw-p_131371-00020" style="text-align: center;"><span href="#/9781847677440_chapter_14#pb-rw_38" title="Link target outside of Sample">Lady’s Song</span>
</p>
<p id="rw-p_131371-00021" style="text-align: center;"><span href="#/9781847677440_chapter_15#pb-rw_39" title="Link target outside of Sample">The ‘Goldfinger Affair’</span>
</p>
<p id="rw-p_131371-00022" style="text-align: center;"><span href="#/9781847677440_chapter_16#pb-rw_42" title="Link target outside of Sample">The Oldest Reason in the World</span>
</p>
<p id="rw-p_131371-00023" style="text-align: center;"><span href="#/9781847677440_chapter_17#pb-rw_44" title="Link target outside of Sample">Is that Jazz?</span>
</p>
<p id="rw-p_131371-00024" style="text-align: center;"><span href="#/9781847677440_chapter_18#pb-rw_46" title="Link target outside of Sample">Lady Day and John Coltrane</span>
</p>
<p id="rw-p_131371-00025" style="text-align: center;"><span href="#/9781847677440_chapter_19" title="Link target outside of Sample">Notes from Reflection on Free Will</span>
</p>
<p id="rw-p_131371-00026" style="text-align: center;"><span href="#/9781847677440_chapter_20#pb-rw_48" title="Link target outside of Sample">Plastic Pattern People</span>
</p>
<p id="rw-p_131371-00027" style="text-align: center;"><span href="#/9781847677440_chapter_21#pb-rw_50" title="Link target outside of Sample">Writer’s Note</span>
</p>
<p id="rw-p_131371-00028" style="text-align: center;"><span href="#/9781847677440_chapter_22#pb-rw_51" title="Link target outside of Sample">Spirits</span>
</p>
<p id="rw-p_131371-00029" style="text-align: center;"><span href="#/9781847677440_chapter_23#pb-rw_52" title="Link target outside of Sample">Inner City Blues</span>
</p>
<p id="rw-p_131371-00030" style="text-align: center;"><span href="#/9781847677440_chapter_24#pb-rw_55" title="Link target outside of Sample">Cane</span>
</p>
<p id="rw-p_131371-00031" style="text-align: center;"><span href="#/9781847677440_chapter_25#pb-rw_56" title="Link target outside of Sample">We Almost Lost Detroit</span>
</p>
<p id="rw-p_131371-00032" style="text-align: center;"><span href="#/9781847677440_chapter_26#pb-rw_57" title="Link target outside of Sample">I Think I’ll Call It Morning</span>
</p>
<p id="rw-p_131371-00033" style="text-align: center;"><span href="#/9781847677440_chapter_27#pb-rw_58" title="Link target outside of Sample">Lovely Day</span>
</p>
<p id="rw-p_131371-00034" style="text-align: center;"><a id="pb-rw_xii">
</a></p><a id="pb-rw_xii">
</a><p id="rw-p_131371-00035" style="text-align: center;"><a id="pb-rw_xii"></a><span href="#/9781847677440_chapter_28#pb-rw_59" title="Link target outside of Sample">Beginnings</span>
</p>
<p id="rw-p_131371-00036" style="text-align: center;"><span href="#/9781847677440_chapter_29#pb-rw_60" title="Link target outside of Sample">No Knock</span>
</p>
<p id="rw-p_131371-00037" style="text-align: center;"><span href="#/9781847677440_chapter_30#pb-rw_61" title="Link target outside of Sample">Billy Green is Dead</span>
</p>
<p id="rw-p_131371-00038" style="text-align: center;"><span href="#/9781847677440_chapter_31#pb-rw_62" title="Link target outside of Sample">Winter in America</span>
</p>
<p id="rw-p_131371-00039" style="text-align: center;"><span href="#/9781847677440_chapter_32#pb-rw_64" title="Link target outside of Sample">The Bottle</span>
</p>
<p id="rw-p_131371-00040" style="text-align: center;"><span href="#/9781847677440_chapter_33#pb-rw_66" title="Link target outside of Sample">When Your Girlfriend has a Better Friend</span>
</p>
<p id="rw-p_131371-00041" style="text-align: center;"><span href="#/9781847677440_chapter_34#pb-rw_68" title="Link target outside of Sample">Pieces of a Man</span>
</p>
<p id="rw-p_131371-00042" style="text-align: center;"><span href="#/9781847677440_chapter_35#h_1" title="Link target outside of Sample">Notes from First Minute of a New Day</span>
</p>
<p id="rw-p_131371-00043" style="text-align: center;"><span href="#/9781847677440_chapter_36#pb-rw_70" title="Link target outside of Sample">Small Talk at 125th and Lenox</span>
</p>
<p id="rw-p_131371-00044" style="text-align: center;"><span href="#/9781847677440_chapter_37#pb-rw_71" title="Link target outside of Sample">Paint it Black</span>
</p>
<p id="rw-p_131371-00045" style="text-align: center;"><span href="#/9781847677440_chapter_38#pb-rw_72" title="Link target outside of Sample">Bridging</span>
</p>
<p id="rw-p_131371-00046" style="text-align: center;"><span href="#/9781847677440_chapter_39#pb-rw_73" title="Link target outside of Sample">Alien</span>
</p>
<p id="rw-p_131371-00047" style="text-align: center;"><span href="#/9781847677440_chapter_40#pb-rw_75" title="Link target outside of Sample">Johannesburg</span>
</p>
<p id="rw-p_131371-00048" style="text-align: center;"><span href="#/9781847677440_chapter_41#pb-rw_76" title="Link target outside of Sample">The Vulture</span>
</p>
<p id="rw-p_131371-00049" style="text-align: center;"><span href="#/9781847677440_chapter_42#pb-rw_77" title="Link target outside of Sample">The Revolution Will Not Be Televised</span>
</p>
<p id="rw-p_131371-00050" style="text-align: center;"><span href="#/9781847677440_chapter_43#pb-rw_80" title="Link target outside of Sample">H<sub>2</sub>O Gate (Watergate) Blues (with intro)</span>
</p>
<p id="rw-p_131371-00051" style="text-align: center;"><span href="#/9781847677440_chapter_45#pb-rw_86" title="Link target outside of Sample">We Beg Your Pardon, America</span>
</p>
<p id="rw-p_131371-00052" style="text-align: center;"><span href="#/9781847677440_chapter_46#pb-rw_91" title="Link target outside of Sample">The Ghetto Code</span>
</p>
<p id="rw-p_131371-00053" style="text-align: center;"><span href="#/9781847677440_chapter_47#pb-rw_96" title="Link target outside of Sample">Bicentennial Blues</span>
</p>
<p id="rw-p_131371-00054" style="text-align: center;"><span href="#/9781847677440_chapter_48#pb-rw_102" title="Link target outside of Sample">Message to the Messengers</span>
</p>
<p id="rw-p_131371-00055" style="text-align: center;"><span href="#/9781847677440_chapter_49#pb-rw_106" title="Link target outside of Sample">Speed Kills</span>
</p>
<p id="rw-p_131371-00056" style="text-align: center;"><span href="#/9781847677440_chapter_50#pb-rw_107" title="Link target outside of Sample">The New Deal</span>
</p>
<p id="rw-p_131371-00057" style="text-align: center;"><span href="#/9781847677440_chapter_51#pb-rw_109" title="Link target outside of Sample">Tuskeegee # 626</span>
</p>
<p id="rw-p_131371-00058" style="text-align: center;"><span href="#/9781847677440_chapter_52#pb-rw_110" title="Link target outside of Sample">King Henry IV</span>
</p>
<p id="rw-p_131371-00059" style="text-align: center;"><span href="#/9781847677440_chapter_53#pb-rw_113" title="Link target outside of Sample">A Poem for Jose Campos Torres</span>
</p>
<p id="rw-p_131371-00060" style="text-align: center;"><span href="#/9781847677440_chapter_54#pb-rw_116" title="Link target outside of Sample">Don’t Give Up</span>
</p>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781847677440_tableofcontents.vue?33a8a1bb